import React from 'react';
import PropTypes from 'prop-types';
import { Tabs as MuiTabs, Tab } from '@mui/material';
import './Tabs.css';

/**
 * Onyx Tabs — sharp underline stage tabs.
 * Prefer StageTabBar for multi-step flows; use Tabs for generic panels.
 * orientation="vertical" covers activity / icon rails (no separate Rail primitive).
 */
export function Tabs({
  value,
  onChange,
  tabs = [],
  orientation = 'horizontal',
  className = '',
  ...props
}) {
  const vertical = orientation === 'vertical';

  return (
    <MuiTabs
      value={value}
      onChange={onChange}
      orientation={orientation}
      className={[
        'onyx-tabs',
        vertical ? 'onyx-tabs--vertical' : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-tabs"
      data-orientation={orientation}
      variant={vertical ? 'standard' : 'scrollable'}
      scrollButtons={vertical ? false : 'auto'}
      {...props}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.icon ? (tab.showLabel ? tab.label : undefined) : tab.label}
          icon={tab.icon || undefined}
          iconPosition={tab.iconPosition || 'top'}
          disabled={tab.disabled}
          title={typeof tab.label === 'string' ? tab.label : undefined}
          aria-label={typeof tab.label === 'string' ? tab.label : undefined}
          className="onyx-tabs__tab"
          data-testid={tab.testId}
          aria-current={value === tab.value ? 'page' : undefined}
        />
      ))}
    </MuiTabs>
  );
}

Tabs.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
      icon: PropTypes.node,
      showLabel: PropTypes.bool,
      iconPosition: PropTypes.oneOf(['top', 'start', 'end', 'bottom']),
      disabled: PropTypes.bool,
      testId: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export default Tabs;
